import { radioGroupAnatomy } from '@chakra-ui/react/anatomy';
import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

import { rem } from '../themeUtils';

const radioGroupSlotRecipe = defineSlotRecipe({
  className: 'radio-group',
  slots: [...radioGroupAnatomy.keys(), 'badge'],
  base: {
    root: {
      display: 'flex',
    },
    item: {
      display: 'inline-flex',
      gap: '8',
      alignItems: 'flex-start',
      justifyContent: 'center',
      cursor: 'pointer',
      _disabled: {
        cursor: 'not-allowed',
      },
      _readOnly: {
        cursor: 'default',
      },
    },
    itemControl: {
      border: '1px solid',
      borderColor: 'border/regular',
      backgroundColor: 'background/primary',
      borderRadius: '50%',
      boxShadow: 'inset/field',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      focusVisibleRing: 'outside',
      '& > .dot': {
        width: '12',
        height: '12',
        borderRadius: '50%',
        backgroundColor: 'icon/interactive',
      },
      _hover: {
        borderColor: 'border/hover',
        _disabled: {
          borderColor: 'border/disabled',
        },
        _readOnly: {
          borderColor: 'border/disabled',
        },
      },
      _disabled: {
        backgroundColor: 'background/disabled',
        borderColor: 'border/disabled',
        boxShadow: 'none',
        '& > .dot': {
          backgroundColor: 'icon/disabled',
        },
      },
      _readOnly: {
        backgroundColor: 'background/disabled',
        borderColor: 'border/disabled',
        boxShadow: 'none',
        '& > .dot': {
          backgroundColor: 'icon/on-disabled',
        },
      },
    },
    itemText: {
      color: 'input/text/inputValue',
      _disabled: {
        color: 'text/disabled',
      },
    },
  },
  variants: {
    orientation: {
      horizontal: {
        root: {
          flexDirection: 'row',
          gap: '24',
        },
      },
      vertical: {
        root: {
          alignItems: 'flex-start',
          flexDirection: 'column',
          gap: '12',
        },
      },
    },
    size: {
      md: {
        badge: {
          paddingBlock: '2',
          width: rem(36),
        },
        itemControl: {
          width: '20',
          height: '20',
        },
        itemText: {
          textStyle: 'body/md/regular',
        },
      },
      lg: {
        badge: {
          paddingBlock: '4',
          width: '40',
        },
        itemControl: {
          width: '24',
          height: '24',
        },
        itemText: {
          textStyle: 'body/lg/regular',
        },
      },
    },
  },
  defaultVariants: {
    orientation: 'horizontal',
    size: 'lg',
  },
});

export default radioGroupSlotRecipe;
